<template>
  <div
    :id="`PropostaCartao${value.id}`"
    class="cartao-proposta"
  >
    <b-row>
      <b-col>
        <tag-cartao-proposta
          :ref="`tagLista${value.id}`"
          :value="value.etiquetas"
          style="margin-top: 0.5rem;"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <span><b>N°</b> {{ value.numeroProposta }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span
          v-b-tooltip.hover.html
          :title="getDadoTooltip(value.pessoaNome)"
          class="limit-character-proposta"
        ><b>Pessoa:</b> {{ value.pessoaNome }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span
          v-b-tooltip.hover.html
          :title="getDadoTooltip(value.gerenteNome)"
          class="limit-character-proposta"
        ><b>Responsável:</b> {{ value.gerenteNome }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span
          v-b-tooltip.hover.html="{ customClass: 'my-tooltip-class' }"
          :title="getTodosContratante()"
          class="limit-character-proposta"
        ><b>Contratante:</b> {{ getContratanteDescricao() }}</span>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 0.15rem;">
      <b-col>
        <span style="font-weight: bold;">{{ valorTotal | converteValor }}</span>
      </b-col>
    </b-row>
    <b-row align-h="between">
      <b-col
        cols="5"
      >
        <div
          v-if="value.validade"
          :class="`validade-badge ${variant}`"
        >
          <feather-icon icon="ClockIcon" /> {{ dataValidade }}</div>
      </b-col>
      <!-- v-if= "value.geraContrato" -->
      <b-col
        v-if="false"
        style="display: flex;align-items: center;"
        cols="auto"
      >
        <font-awesome-icon
          class="fa-lg text-success"
          :icon="faFileAlt"
        />
      </b-col>
      <b-col
        align-self="center"
        cols="auto"
        class="mr-50"
      >
        <div style="display: flex;">
          <div
            v-if="value.tramite"
            v-b-tooltip.hover
            title="Existem trâmites na proposta!"
            class="cor-tramite"
          >
            <font-awesome-icon
              style="color: rgba(0, 121, 191);"
              :icon="faComment"
            />
          </div>
          <div
            v-if="value.observacao"
            v-b-tooltip.hover
            title="Nessa proposta há observações!"
            class="cor-observacao"
          >
            <font-awesome-icon
              style="color: rgba(251, 140, 0);"
              :icon="faBell"
            />
          </div>
          <div
            v-if="value.statusOmie !== 0 && (value.statusProposta === 8 || value.statusProposta === 4 || value.statusProposta === 9)"
            v-b-tooltip.hover
            :title="getTitulo(value.statusOmie)"
            :class="[{'sucesso-integracao': sucessoIntegracao(value.statusOmie)}, {'erro-integracao': erroIntegracao(value.statusOmie)}, {'pendente-integracao': pendenteIntegracao(value.statusOmie)}]"
          >
            <font-awesome-icon
              :icon="faRobot"
              :class="getStatusOmie(value.statusOmie)"
              style="font-size:1.2rem !important;"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
.cartao-proposta {
  padding-left: 0.3rem;
  padding-bottom: 0.5rem;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 0 #091e4240;
  cursor: pointer;
  display: block;
  margin-bottom: 8px;
  max-width: 100%;
  min-height: 20px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  font-size: 13px;
}

.validade-badge {
  display: inline-block;
  font-size: 85%;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  color: #fff;
  padding: 0.3rem 0.5rem;
  text-align: center;
  border-radius: 0.3rem;
}

.vencimento-badge {
  background-color: #d9534f;
}

.longe-vencimento-badge {
  background-color: #949494;
}

.limit-character-proposta {
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.cor-tramite {
  border-radius: 0.2rem;
  background-color: rgba(0, 121, 191, 0.3);
  padding: 3px 3.8px;
  margin-right: 0.2rem;
}

.cor-observacao {
  border-radius: 0.2rem;
  background-color: rgba(251, 140, 0, 0.3);
  padding: 3px 3.8px;
}
.sucesso-integracao {
  border-radius: 0.1rem;
  background-color: #ffffff;
  padding: 1.5px;
  color: #28c76f
}

.erro-integracao {
  border-radius: 0.1rem;
  background-color:#ffffff;
  padding: 1.5px;
  color: #ea5455
}

.pendente-integracao {
  border-radius: 0.1rem;
  background-color:#ffffff;
  padding: 1.5px;
  color: #ffc107
}

.my-tooltip-class > .tooltip-inner{
  /* Removes the default max-width */
  max-width: 450px !important;
}
</style>

<script>
import {
  faRobot,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faComment, faBell,
} from '@fortawesome/free-regular-svg-icons'

export default {
  name: 'CartaoProposta',
  components: {
    FontAwesomeIcon,
    TagCartaoProposta: () => import('@/app-modulo/comercial/proposta/shared/components/tag-cartao-proposta/tag-cartao-proposta.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      faFileAlt,
      faComment,
      faBell,
      faRobot,
    }
  },
  computed: {
    valorTotal() {
      if (!this.value.valor) {
        return 0
      }
      return this.value.valor
    },
    dataValidade() {
      moment.locale('pt-BR')
      return `${moment(this.value.validade).format('DD')} de ${moment(this.value.validade).format('MMM')}`
    },
    variant() {
      if (this.value.noVencimento) {
        return 'vencimento-badge'
      }
      return 'longe-vencimento-badge'
    },
  },
  methods: {
    getTitulo(omie) {
      if (omie === 2) {
        return 'Integração Omie com sucesso'
      }
      if (omie === 1) {
        return 'Integração Omie pendente'
      }
      return 'Integração Omie com erro'
    },
    getStatusOmie(statusOmieEmpresa) {
      if (statusOmieEmpresa === 1) {
        return 'pendente-integracao'
      }
      if (statusOmieEmpresa === 2) {
        return 'sucesso-integracao'
      }
      if (statusOmieEmpresa === 3) {
        return 'erro-integracao'
      }
      return ''
    },
    sucessoIntegracao(omie) {
      return omie === 2
    },
    erroIntegracao(omie) {
      return omie === 3
    },
    pendenteIntegracao(omie) {
      return omie === 1
    },
    validarStatusOmie(omie) {
      return omie != null && (omie === 1 || omie === 2 || omie === 3)
    },
    getContratanteDescricao() {
      if (this.value.semContratante) {
        return this.value.semContratante.split(';')[0]
      }
      if (this.value.contratantes && this.value.contratantes.length > 0) {
        return this.value.contratantes[0].split(';')[0]
      }
      return ''
    },
    getTodosContratante() {
      if (this.value.semContratante) {
        return `<div style="font-size: 10px;">${this.value.semContratante.replace(/;/g, ' - ')}</div>`
      }
      if (this.value.contratantes && this.value.contratantes.length > 0) {
        return `<div style="font-size: 10px;">${this.value.contratantes.join('<br>').replace(/;/g, ' - ')}</div>`
      }
      return ''
    },
    getDadoTooltip(value) {
      return `<div style="font-size: 10px;">${value}</div>`
    },
  },
}
</script>
